import axios from "axios";
import * as ActionTypes from "./actionTypes";
import * as urls from "../common/urls";

export function getActivePromotions() {
  const request = axios.get(urls.PROMOTIONS_URL);
  return { type: ActionTypes.GET_ACTIVE_PROMOTIONS, payload: request };
}


export function getPromotionItems(checkoutSale, promotionTypeId = null) {
  let url = `${urls.Get_Promotion_Items}`;

  if (promotionTypeId !== null) {
    url += `?promotionTypeId=${promotionTypeId}`;
  }

  return {
    type: ActionTypes.GET_PROMOTIONS_ITEMS,
    payload: axios.post(url, checkoutSale)
  };
}

export function resetPromotionItems() {
  return {
    type: ActionTypes.RESET_GET_PROMOTIONS_ITEMS
  };
}

export function getStockItemToAdd(payload) {
  return {
    type: ActionTypes.GET_StockItem_To_Add,
    payload: axios.post(urls.GET_StockItem_To_Add, payload)
  };
}